// Anagrafica clienti: persone che hanno fatto il check-in o hanno dati di fatturazione.
export const clientesDir = {
  title: "Clienti",
  subtitle: "Tutte le persone che hanno fatto il check-in o hanno dati di fatturazione. Vengono salvate automaticamente e mai duplicate.",
  searchLabel: "Cerca cliente",
  searchPlaceholder: "Nome, documento, e-mail o telefono",
  filters: {
    todos: "Tutti",
    checkin: "Con check-in",
    fiscal: "Con dati fiscali",
    reservas: "Con prenotazioni",
  },
  cols: {
    client: "Cliente",
    document: "Documento",
    phone: "Telefono",
    stays: "Soggiorni",
    lastStay: "Ultimo soggiorno",
  },
  checkins: "{n} check-in | {n} check-in",
  bookings: "{n} prenotazione | {n} prenotazioni",
  fiscalBadge: "Fiscale",
  noDocument: "Senza documento",
  noName: "Senza nome",
  emptyTitle: "Ancora nessun cliente",
  emptyText: "Chiunque completi un check-in apparirà qui automaticamente.",
  emptySearch: "Nessun cliente corrisponde a «{q}».",
  loadError: "Impossibile caricare i clienti.",
  pageOf: "{from}–{to} di {total}",
  prev: "Precedente",
  next: "Successivo",
  docTypes: {
    P: "Passaporto",
    ID: "Documento nazionale d'identità",
    IM: "NIE",
    I: "Carta d'identità",
    D: "Documento nazionale d'identità",
    N: "NIE",
    X: "Permesso di soggiorno",
    CC: "Carta di cittadinanza",
    CE: "Carta d'identità per stranieri",
    TI: "Carta d'identità",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Chiudi",
    createBooking: "Crea prenotazione",
    personal: "Dati personali",
    document: "Documento",
    address: "Indirizzo",
    fiscal: "Dati fiscali",
    noFiscal: "Nessun dato fiscale. Vengono aggiunti durante la fatturazione o da Fatturazione → Clienti fiscali.",
    defaultProfile: "Predefinito",
    bookings: "Prenotazioni",
    noBookings: "Nessuna prenotazione collegata.",
    companions: "Ha viaggiato con",
    noCompanions: "Non ha condiviso una prenotazione con nessun altro.",
    timesTogether: "{n} volta | {n} volte",
    invoices: "Fatture",
    noInvoices: "Nessuna fattura.",
    viewPdf: "Visualizza PDF",
    email: "E-mail",
    phone: "Telefono",
    birthDate: "Data di nascita",
    sex: "Sesso",
    nationality: "Nazionalità",
    docType: "Tipo",
    docNumber: "Numero",
    expiry: "Scadenza",
    support: "Numero di supporto",
    street: "Indirizzo",
    zip: "CAP",
    city: "Città",
    country: "Paese di residenza",
    roleCheckin: "Check-in",
    roleHolder: "Titolare",
    loadError: "Impossibile aprire la scheda del cliente.",
  },
  sexes: {
    M: "Maschio",
    F: "Femmina",
  },
  picker: {
    missingPolice: "Per questo cliente non ci sono dati di polizia salvati in questo account. Completali ora e resteranno per la prossima volta.",
    searchSaved: "Cerca cliente salvato",
    searchPlaceholder: "Nome, documento o telefono…",
    noResults: "Nessun cliente salvato corrisponde.",
    selected: "Dati compilati da Clienti",
    clear: "Rimuovi",
  },
  match: {
    title: "Questo cliente esiste già",
    text: "{name} è già salvato in Clienti. Puoi compilare tutti i suoi dati con un solo tocco.",
    use: "Usa i suoi dati",
    dismiss: "Non è questa persona",
    applied: "Dati di {name} compilati. Controlla le date del soggiorno e firma.",
    companionsTitle: "Ha già viaggiato con",
    companionsHint: "Tocca una persona per registrarla con i suoi dati.",
    registerCompanion: "Registra {name}",
  },
};
